// components/features/orders/OrdersList.tsx
import { Order } from "../../../types/Order";
import TableList, { SelectAction } from "../../ui/TableList";
import OrderRow from "./OrderRow";

interface OrdersListProps {
  orders: Order[];
  onAction: (order: Order) => void;
  onSelectOrders?: (selectedOrders: Order[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function OrdersList({
  orders,
  onAction,
  onSelectOrders,
  selectable = false,
  selectActions
}: OrdersListProps) {
  const columns = [
    { header: "Référence", className: "w-1/6" },
    { header: "Client", className: "hidden sm:table-cell w-1/6" },
    { header: "Email", className: "hidden lg:table-cell w-1/5" },
    { header: "Articles", className: "hidden md:table-cell w-1/12" },
    { header: "Total", className: "hidden sm:table-cell w-1/6" },
    { header: "Statut", className: "w-1/6" },
    { header: "Date", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={orders}
      columns={columns}
      getId={(order) => order.orderId}
      onAction={onAction}
      onSelectItems={onSelectOrders}
      selectable={selectable}
      emptyMessage="Aucune commande trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(order, isSelected, onSelect) => (
        <OrderRow
          key={order.orderId}
          order={order}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}